import { Button, DeleteIcon, Menu, MoreIcon } from "melco-ui";
import { Dropdown } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import isEmpty from "lodash/isEmpty";
import { useConfirm } from "../../hooks/useConfirm";
import { EfsMelcoEfsModelsFormat } from "melco-shared-logic";
import { useDeleteInputFormats } from "../../hooks/inputFormats/useDeleteInputFormats";

type InputFormatMoreActionButtonProps = {
  inputFormat: EfsMelcoEfsModelsFormat;
};

export const InputFormatMoreActionButton: React.FC<
  InputFormatMoreActionButtonProps
> = ({ inputFormat }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const deleteInputFormats = useDeleteInputFormats();

  const confirmDelete = useConfirm(
    async () => {
      if (inputFormat.id) {
        const successfullyDeletedIds = await deleteInputFormats([
          inputFormat.id,
        ]);

        // redirect to list view in case the entity was deleted successfully
        if (!isEmpty(successfullyDeletedIds)) {
          navigate(`/input-formats`);
        }
      }
    },
    {
      translationPrefix: "inputFormats.actions.delete",
      translationOptions: {
        count: 1,
      },
    }
  );

  const MoreActions = (
    <Menu>
      <Menu.Item
        key="more-actions-delete"
        danger
        onClick={() => {
          confirmDelete();
        }}
      >
        <DeleteIcon /> {t("inputFormats.actions.delete.button")}
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown
      overlay={MoreActions}
      trigger={["click"]}
      placement="bottomRight"
      arrow
    >
      <Button
        key="input-format-more-actions"
        icon={<MoreIcon />}
        data-cy-id="input-format-more-actions"
      />
    </Dropdown>
  );
};
